module.exports = __webpack_public_path__ + "img/qjwx_log.bb9b3632.png";